/* @ngInject */
function strongPasswordService (CONSTANTS, Utils, ConnectorWebService) {
  const service = {
    checkIfNeedsStrongPassword,
    verifyPasswordStrength,
    updatePassword
  }

  return service

  function checkIfNeedsStrongPassword (token) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUTH_STRONG_PASSWORD_VALIDATE_TOKEN, [token])

    return ConnectorWebService.get(url)
  }

  function verifyRuleEight (password, passwordRules) {
    passwordRules.eight = password.length >= 8
  }

  function verifyRuleUppercase (password, passwordRules) {
    passwordRules.uppercase = /[A-Z]/.test(password)
  }

  function verifyRuleLowercase (password, passwordRules) {
    passwordRules.lowercase = /[a-z]/.test(password)
  }

  function verifyRuleNumber (password, passwordRules) {
    passwordRules.number = /[0-9]/.test(password)
  }

  function verifyRuleSpecial (password, passwordRules) {
    passwordRules.special = /[^A-Za-z0-9]/.test(password)
  }

  function getPasswordStrength (checkCount) {
    const classes = {
      0: 'NONE',
      1: 'ONE',
      2: 'TWO',
      3: 'THREE',
      4: 'FOUR',
      5: 'FIVE'
    }

    return classes[checkCount]
  }

  function verifyPasswordStrength (password, passwordRules) {
    verifyRuleEight(password, passwordRules)
    verifyRuleUppercase(password, passwordRules)
    verifyRuleLowercase(password, passwordRules)
    verifyRuleNumber(password, passwordRules)
    verifyRuleSpecial(password, passwordRules)

    let ruleCheckCount = 0

    for (const rule in passwordRules) {
      if (passwordRules[rule]) {
        ruleCheckCount++
      }
    }

    return getPasswordStrength(ruleCheckCount)
  }

  function updatePassword (token, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUTH_PASSWORD_TOKEN, [token])

    return ConnectorWebService.put(url, payload)
  }
}

export { strongPasswordService }
